export const vbudgetWorkflowGuide =
  'How virtual budgets work: users have a main customer budget they cannot modify, and a tree of ' +
  'sub-budgets (virtual budgets) under it. Amounts are stored in cents (500000 = 5,000.00 CHF). ' +
  'Use get_virtual_budgets to inspect the tree (and optionally select a node). ' +
  'create_virtual_budget / update_virtual_budget / delete_virtual_budget persist immediately and are sensitive. ' +
  'A budget with spending cannot be deleted; a fully spent budget cannot be edited.';
